import React from "react";

/**
 * Wordmark-only brand logo for header/footer (no monogram icon).
 * size: 'sm' | 'md' | 'lg'
 */
const PRESETS = {
  sm: { title: "text-base md:text-lg", subtitle: "text-[10px] md:text-[11px]", caption: "text-[8px] md:text-[9px]" },
  md: { title: "text-xl md:text-2xl",  subtitle: "text-[11px] md:text-xs",     caption: "text-[9px] md:text-[10px]" },
  lg: { title: "text-2xl md:text-3xl", subtitle: "text-sm md:text-base",       caption: "text-[10px] md:text-[11px]" },
};

export default function BrandLogo({ size = "md", showTagline = true, className = "" }) {
  const c = PRESETS[size] || PRESETS.md;
  return (
    <div className={`leading-none ${className}`}>
      <div className={`font-display text-white ${c.title} tracking-wide flex items-baseline gap-1.5`}>
        <span>PRODUCERS</span>
        <span className="text-[#3b7df0]">TODAY</span>
        <sup className="text-[8px] text-white/60 -translate-y-1">TM</sup>
      </div>
      {showTagline && (
        <div className="flex items-baseline gap-2 mt-1">
          <span className={`font-italic-serif text-[#e63946] ${c.subtitle}`}>Annuity</span>
          <span className={`${c.caption} text-white/55 uppercase tracking-[0.16em]`}>The Voice of the Producers</span>
        </div>
      )}
    </div>
  );
}
